const features = [
  { selector: 'product-gallery, product-gallery-navigation, open-lightbox-button', load: () => import('theme-product-gallery') },
  { selector: 'before-after', load: () => import('theme-before-after') },
  { selector: 'countdown-timer, countdown-timer-flip, countdown-timer-flip-digit', load: () => import('theme-countdown') },
  { selector: 'quick-order-list, quick-order-list-quantity-selector, quick-order-list-remove-variant, quick-order-list-remove-all', load: () => import('theme-quick-order') },
  { selector: 'shop-the-look-mobile-carousel, shop-the-look-product-list-carousel, shop-the-look-desktop-carousel, shop-the-look-popover', load: () => import('theme-shop-the-look') },
];

function prepareFeatures(root) {
  for (const feature of features) {
    if (feature.loading || !(root.matches?.(feature.selector) || root.querySelector?.(feature.selector))) continue;
    feature.loading = feature.load().catch(error => {
      feature.loading = null;
      console.error('Unable to prepare theme section', error);
    });
  }
}

prepareFeatures(document);
// Section rendering and quick-buy HTML insertion do not execute script tags.
// Inspect only newly inserted subtrees; initial sections have module tags so
// their files are discovered while parsing, without waiting for interaction.
new MutationObserver(mutations => {
  const roots = new Set();
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) if (node.nodeType === 1) roots.add(node);
  }
  for (const root of roots) {
    let parent = root.parentElement;
    while (parent && !roots.has(parent)) parent = parent.parentElement;
    if (!parent) prepareFeatures(root);
  }
}).observe(document.documentElement, { childList: true, subtree: true });
document.addEventListener('shopify:section:load', event => prepareFeatures(event.target));
